// import store from "../store";
// import store from "../../../store";
// import { OPEN_RFP_DIALOG } from "../store/actions";
// import rfp from "../views/Rfp.vue";

const rfp = () => import('../views/Rfp.vue');
const RfpDetails = () => import ('../views/RfpDetailsView.vue');
const PostRequest=()=> import ('../views/PostRequest.vue');
const PostRequestSubmitted=()=>import('../views/PostRequestSubmitted.vue');


export default [{
        path: "/rfp",
        name: "RFP",
        component: rfp,
        // beforeEnter: (to, from, next) => {
        //     // store.dispatch(OPEN_RFP_DIALOG);
        // },
    },
    {
        path: "/rfp/rfp-details/:rfpId",
        name: "rfpDisplayLink",
        component: RfpDetails,
    },

 
    {
        path: "/post-request",
        name: "postRequest",
        component: PostRequest,
    },

    {
        path: "/post-request/edit/:id?",
        name: "postRequest-edit",
        component: PostRequest,
    },
    {
        path:'/post-request-submitted',
        name:'postRequestSubmitted',
        component: PostRequestSubmitted,
    },
    
];